import { PartnerJsonApiEntity } from '@onevision-resources/json-api-parser';

export enum InputType {
  input = 'input',
  datePicker = 'datePicker',
  toggle = 'toggle',
  phone = 'phone',
  email = 'email',
}

export interface ListItem {
  name: keyof PartnerJsonApiEntity['attributes'];
  label: string;
  inputType: InputType;
}

export const fieldsList: ListItem[] = [
  {
    name: 'currentPartner',
    label: 'Current partner',
    inputType: InputType.toggle,
  },
  {
    name: 'businessName',
    label: 'Business Name',
    inputType: InputType.input,
  },
  {
    name: 'revenueShare',
    label: 'Revenue Share',
    inputType: InputType.input,
  },
  {
    name: 'contractSignedDate',
    label: 'Contract Signed',
    inputType: InputType.datePicker,
  },
  {
    name: 'supportLiveDate',
    label: 'Support Live',
    inputType: InputType.datePicker,
  },
  {
    name: 'marketingLaunchDate',
    label: 'Marketing Live',
    inputType: InputType.datePicker,
  },
  {
    name: 'litsDate',
    label: 'LitS',
    inputType: InputType.datePicker,
  },
  {
    name: 'membershipUrlNew',
    label: 'Membership URL Res',
    inputType: InputType.input,
  },
  {
    name: 'membershipUrlComNew',
    label: 'Membership URL Com',
    inputType: InputType.input,
  },
  {
    name: 'zendeskUrl',
    label: 'Zendesk URL',
    inputType: InputType.input,
  },
  {
    name: 'zendeskDomain',
    label: 'Zendesk Domain',
    inputType: InputType.input,
  },
  {
    name: 'dosCalendly',
    label: 'Pdev MPOC Calendly URL',
    inputType: InputType.input,
  },
  {
    name: 'notionBoardUrl',
    label: 'Marketing Review URL',
    inputType: InputType.input,
  },
  {
    name: 'docsendUrl',
    label: 'Onboarding Resources URL',
    inputType: InputType.input,
  },
  {
    name: 'stripeAccountId',
    label: 'Stripe Account ID',
    inputType: InputType.input,
  },
  {
    name: 'stripeCustomerId',
    label: 'Stripe Customer ID',
    inputType: InputType.input,
  },
  {
    name: 'iterableTestUserId',
    label: 'Iterable Test User ID',
    inputType: InputType.input,
  },
  {
    name: 'globalNotificationEmail',
    label: 'Global Notification Email',
    inputType: InputType.email,
  },
];
